module.exports = __webpack_public_path__ + "img/a1-s36.866af9a8.jpg";